export const GET_LIST_FILE_TAGS = "GET_LIST_FILE_TAGS";
export const GET_LIST_FILE_TAGS_SUCCESS =
  "GET_LIST_FILE_TAGS_SUCCESS";
export const GET_LIST_FILE_TAGS_ERROR =
  "GET_FILE_TAGS_ERROR";